import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import React, { useRef } from 'react';
import { Select } from '../../../ui/Select';
import { RangeFilter } from '../../../ui/RangeFilter';
import { getRangeFilterValue } from '../../../../utils/helpers/getRangeFilterValue';
import { ManatIcon, PricePlaceholderContainer } from './styled';
import { CurrencySymbol } from '../../../ui/ItemCard/CurrencySymbol';
import { FilterFieldProps, SelectRefType } from '../types';
import { actionButtonStyles, RangeFilterWrapper } from '../styled';
import { ModalFooter } from '../../../ui/Modal/ModalFooter';
import useScreenSize from '../../../../hooks/useScreenSize';
import { useFilterChangeSubmit } from '../../../../hooks/useFilterChangeSubmit';
import { getBasedDataStatValueInFilters } from '../../../../utils/helpers/common';

const units = (
  <ManatIcon>
    <CurrencySymbol currency="AZN" />
  </ManatIcon>
);

export const PriceFilter: React.FC<FilterFieldProps> = ({
  submitOnChange = false,
  isPashaLanding
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();
  const { isSmall } = useScreenSize();
  const selectRef = useRef<SelectRefType>(null);
  const basedDataStat = getBasedDataStatValueInFilters(isPashaLanding);

  const fromValue = values.price_from;
  const toValue = values.price_to;

  const { handleClose } = useFilterChangeSubmit(
    fromValue,
    toValue,
    submitOnChange
  );

  const resetButtonIsDisabled = !fromValue && !toValue;

  const pricePlaceholder = (
    <PricePlaceholderContainer>
      {`${t('new_search.price')}, `}
      {units}
    </PricePlaceholderContainer>
  );
  const selectedValue = getRangeFilterValue({
    fromValue,
    toValue,
    units,
    t
  });

  const onReset = () => {
    change('price_from', '');
    change('price_to', '');
  };

  const onSubmit = () => {
    if (selectRef.current) {
      selectRef.current?.closePopover();
    }
    handleClose();
  };

  return (
    <Select
      ref={selectRef}
      placeholder={pricePlaceholder}
      value={selectedValue}
      cypress={`${basedDataStat}-price-filter`}
      stat={`${basedDataStat}-price-filter`}
      width={300}
      onClose={handleClose}
      modalTitle={pricePlaceholder}
      modalCypress="filter-modal"
      showModalHeaderBorder={!isPashaLanding}
    >
      <RangeFilterWrapper>
        <RangeFilter
          minId={`${basedDataStat}-form-price-from`}
          minName="price_from"
          maxName="price_to"
          maxId={`${basedDataStat}-form-price-to`}
        />
      </RangeFilterWrapper>

      {isSmall && (
        <ModalFooter
          resetIsDisabled={resetButtonIsDisabled}
          onReset={onReset}
          onConfirm={onSubmit}
          resetText={t('common.reset')}
          confirmText={t('common.apply')}
          confirmCypress="apply-btn"
          resetCypress="reset-btn"
          styles={actionButtonStyles}
        />
      )}
    </Select>
  );
};
